import axiosClient from "../axiosInstance";

const adminBase = "/admin/api-keys";

/**
 * API keys for machine clients - the BowlScout import and its lookups, and the
 * hosted MCP endpoint external users and organisations connect their own AI
 * clients to. Admin only.
 *
 * The server stores only a hash of each key, so `createApiKey` is the one and
 * only time the plaintext is available - it comes back in `data.key` and can
 * never be fetched again.
 */

/** List keys. Each row carries `queries_30d` and its MCP scope and organisation. */
export const listApiKeys = async () => {
  const response = await axiosClient.get(adminBase);
  return response.data;
};

/**
 * Create a key. Omit `mcp_scope` for a key with no MCP access - the fail-closed
 * default, and what a BowlScout import key wants.
 *
 * @param {{name: string, mcp_scope?: "rankings"|"admin"|null, organisation_id?: number|null}} payload
 */
export const createApiKey = async (payload) => {
  const response = await axiosClient.post(adminBase, payload);
  return response.data;
};

/**
 * Grant, change or remove a key's MCP access. Passing mcp_scope null removes
 * it; the key keeps working for its other machine endpoints.
 */
export const updateApiKeyMcp = async (id, payload) => {
  const response = await axiosClient.post(`${adminBase}/${id}/mcp`, payload);
  return response.data;
};

/** Daily MCP query counts for one key, newest first. */
export const getApiKeyUsage = async (id, days = 30) => {
  const response = await axiosClient.get(`${adminBase}/${id}/usage`, {
    params: { days },
  });
  return response.data;
};

export const revokeApiKey = async (id) => {
  const response = await axiosClient.post(`${adminBase}/${id}/revoke`);
  return response.data;
};

const apiKeysService = {
  listApiKeys,
  createApiKey,
  updateApiKeyMcp,
  getApiKeyUsage,
  revokeApiKey,
};

export default apiKeysService;
